
export default {
  props: {
    type: {
      type: String,
      default: "text",
    },
    error: {
      type: [Boolean],
      default: false,
    },
    showError: {
      type: [Boolean],
      default: true,
    },
    errorMsg: {
      type: [String],
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    textarea: {
      type: Boolean,
      default: false,
    },
    inputId: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
